module.exports = __webpack_public_path__ + "media/images/icons/filled/tool-35032a613ad17a0168a78c6ff66a0da9.svg";